/* eslint-disable react/prop-types */

import React from 'react';
import Tab from './Tab';

export default function ArchivedObjectPrint({tabs, Field}) {
  return (
    <div id="DisplayMetadataPrintDiv">
      {
        tabs.map((tab, i) => {
          return (
            <div className="print-tab" key={i}>
              <h1 className="print-tab-header">{tab.label}</h1>
              <Tab tab={tab} Field={Field} mode='print' />
            </div>
          );
        })
      }
    </div>
  );
}